/*
 * @Author: Yve
 * @Date: 2022-11-09 10:28:51
 * @Last Modified by: Yve
 * @Last Modified time: 2022-11-10 14:19:06
 */
import axios from "axios";
import { message } from "antd";

interface axiosProps {
  "Content-Type"?: string;
  defaults?: any;
  [key: string]: any;
}

const Axios: axiosProps = axios.create();
Axios.defaults.timeout = 60 * 1000;
Axios.defaults.withCredentials = false;
Axios.defaults.headers["Content-Type"] = "application/json";
Axios.defaults.transformRequest = [
  (data: any) => {
    if (Object.prototype.toString.call(data) === "[object FormData]") {
      return data;
    }
    return typeof data === "object" ? JSON.stringify(data) : data;
  }
];

// 请求拦截
Axios.interceptors.request.use(
  (config: any) => {
    config.baseURL = process.env.REACT_APP_API_ROOT;
    const token = sessionStorage.getItem("accessToken");
    // config.headers.common["Authorization"] = "Bearer " + token;
    config.headers.common["token"] = token;
    config.headers.common["Language"] =
      localStorage.getItem("language") || "zh-CN";
    //get时当参数为数组的时候转化成字符串用逗号拼接
    if (config.method === "get" && config.params) {
      Object.keys(config.params).forEach((e: any) => {
        if (config.params[e] instanceof Array) {
          config.params[e] = config.params[e].join(",");
        }
      });
    }
    return config;
  },
  (err: any) => {
    return Promise.reject(err);
  }
);

// 响应拦截
Axios.interceptors.response.use(
  (res: any) => {
    // 下载文件
    if (res.config.responseType === "blob") return res;

    if (
      (res.status === 200 || res.status === 201) && res.data.code === 200
    ) {
      if (res.data.success || res.data.result === "SUCCESS" || res.data.code === 200) {
        return res.data.data;
      } else if (typeof res.data === "string") {
        return res;
      } else {
        return res.data;
      }
    } else if (res.status === 200 && res?.data?.success !== false) {
      if (res.data.code === 0 || res.data.code === 10000 || res.data.code === 500 ) {
        message.destroy();
        message.error(res.data.message);
        return Promise.reject(res);
      }
      return res;
    } else {
      message.destroy();
      message.error(res.data.message);
      return Promise.reject(res);
    }
  },
  (err: any) => {
    if (err) {
      console.log(err?.response?.data);
      if (err?.response?.status === 401) {
        message.destroy();
        message.error("没权限");
        return;
      }
      message.error(
        err?.response?.data.err_msg ||
        err?.response?.data.errMsg ||
        err?.response?.data?.message
      );
    }
    return Promise.reject(err?.response?.data);
  }
);

export default Axios;
